import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  @Output() menuToggled: EventEmitter<any> = new EventEmitter();

  hiddenContainer = new EventEmitter<boolean>();

  hideContainer(hide: boolean) {
    this.hiddenContainer.emit(hide);
  }

  toggleMenu() {
    this.menuToggled.emit();
  }
}
